import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';

export interface CallHistoryData {
  businessPhoneNumber: string;
  welcomeMessage: string;
  hoursLocationMessage: string;
  servicesPricingMessage: string;
  escalationProtocol: string;
  upsellProtocol: string;
  escalationPhoneNumber: string;
}

export const getCallHistoryData = (
  businessId: number,
  startDate: string,
  endDate: string,
): AxiosPromise<CallHistoryData> => {
  let url = `/assist/reporting/callHistory/retell?startDate=${startDate}&endDate=${endDate}`;
  if (businessId) {
    url += `&businessId=${businessId}`;
  }
  return httpClient({
    method: 'GET',
    url,
  });
};
